import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { withDefaultAriaLabel } from "@/aria";
import { cx } from "@/lib/cx";
import { RuiIconChevronDown } from "@/lib/icons";
import { RuiAutocomplete, RuiAutocompleteCollection, RuiAutocompleteEmpty } from "../autocomplete";
import { RuiListbox } from "../listbox";
import "./combobox.script";
export function RuiComboboxControl({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-combobox__control", className),
    children
  });
}
export function RuiComboboxInput({
  placeholder,
  disabled,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("input", {
    ...props,
    type: "text",
    "data-combobox-input": true,
    "data-autocomplete-input": true,
    "data-rui-control": true,
    "data-rui-control-type": "text",
    class: cx("rui-combobox__input", className),
    placeholder,
    disabled,
    autocomplete: "off"
  });
}
export function RuiComboboxTrigger({
  children,
  class: className,
  aria,
  disabled,
  ...props
}) {
  return /* @__PURE__ */jsx("button", {
    ...props,
    aria: withDefaultAriaLabel(aria, "Show suggestions"),
    type: "button",
    "data-combobox-trigger": true,
    class: cx("rui-control-toggle", className),
    disabled,
    tabIndex: -1,
    children: children ?? /* @__PURE__ */jsx(RuiIconChevronDown, {})
  });
}
export function RuiComboboxListbox({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-combobox-listbox": true,
    class: cx("rui-combobox__listbox rui-popover rui-popover--listbox rui-floating", className),
    children
  });
}
function ComboboxShell({
  children
}) {
  return /* @__PURE__ */jsx("div", {
    class: "rui-combobox",
    "data-ref": "root",
    children
  });
}
export function RuiCombobox({
  options,
  children,
  ...props
}) {
  if (options != null) {
    return /* @__PURE__ */jsx("rui-combobox", {
      ...props,
      children: /* @__PURE__ */jsxs(ComboboxShell, {
        children: [/* @__PURE__ */jsxs(RuiComboboxControl, {
          children: [/* @__PURE__ */jsx(RuiComboboxInput, {
            placeholder: props.placeholder,
            disabled: props.disabled
          }), /* @__PURE__ */jsx(RuiComboboxTrigger, {})]
        }), /* @__PURE__ */jsx(RuiComboboxListbox, {
          children: /* @__PURE__ */jsx(RuiAutocomplete, {
            children: /* @__PURE__ */jsxs(RuiAutocompleteCollection, {
              children: [/* @__PURE__ */jsx(RuiListbox, {
                embedded: true,
                options
              }), /* @__PURE__ */jsx(RuiAutocompleteEmpty, {
                children: "No results found."
              })]
            })
          })
        })]
      })
    });
  }
  return /* @__PURE__ */jsx("rui-combobox", {
    ...props,
    children: /* @__PURE__ */jsx(ComboboxShell, {
      children
    })
  });
}